module.exports = __webpack_public_path__ + "static/media/alg.6f153899.png";